"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12.9822 7c.8285 0 1.5-.6716 1.5-1.5s-.6715-1.5-1.5-1.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5zm1.5292 4.4158a.7135.7135 0 0 1-.2176-.1684l-.6471-.7398-.1891 3.0206 1.4572 2.9148a.9247.9247 0 0 1 .0628.164l1.0701 3.9239L14.3269 21 13.28 17.1617l-1.1383-2.2758-.7455 2.238a.8942.8942 0 0 1-.1499.2751l-2.8537 3.5671L7 19.8521l2.7546-3.443.8233-2.471.2607-4.2385-.7908.4944-.9824 2.2916-1.3113-.5622 1.0701-2.497a.7124.7124 0 0 1 .2772-.324l1.8239-1.1396a2.1314 2.1314 0 0 1 2.7453.4059l1.6045 1.8335 2.0151 1.0074-.6385 1.2763-2.1403-1.0701z"
  })];
};

exports.default = _default;